import createIcon from '../../createIcon';

/**
 * @component @name VideogameAsset
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNkgzQzEuOSA2IDEgNi45IDEgOFYxNkMxIDE3LjEgMS45IDE4IDMgMThIMjFDMjIuMSAxOCAyMyAxNy4xIDIzIDE2VjhDMjMgNi45IDIyLjEgNiAyMSA2Wk0yMSAxNkgzVjhIMjFWMTZaTTYgMTVIOFYxM0gxMFYxMUg4VjlINlYxMUg0VjEzSDZWMTVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTQuNSAxNUMxNS4zMjg0IDE1IDE2IDE0LjMyODQgMTYgMTMuNUMxNiAxMi42NzE2IDE1LjMyODQgMTIgMTQuNSAxMkMxMy42NzE2IDEyIDEzIDEyLjY3MTYgMTMgMTMuNUMxMyAxNC4zMjg0IDEzLjY3MTYgMTUgMTQuNSAxNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOC41IDEyQzE5LjMyODQgMTIgMjAgMTEuMzI4NCAyMCAxMC41QzIwIDkuNjcxNTcgMTkuMzI4NCA5IDE4LjUgOUMxNy42NzE2IDkgMTcgOS42NzE1NyAxNyAxMC41QzE3IDExLjMyODQgMTcuNjcxNiAxMiAxOC41IDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VideogameAsset = createIcon('VideogameAsset', [
  [
    'path',
    {
      d: 'M21 6H3C1.9 6 1 6.9 1 8V16C1 17.1 1.9 18 3 18H21C22.1 18 23 17.1 23 16V8C23 6.9 22.1 6 21 6ZM21 16H3V8H21V16ZM6 15H8V13H10V11H8V9H6V11H4V13H6V15Z',
      key: '1g9ykt',
    },
  ],
  [
    'path',
    {
      d: 'M14.5 15C15.3284 15 16 14.3284 16 13.5C16 12.6716 15.3284 12 14.5 12C13.6716 12 13 12.6716 13 13.5C13 14.3284 13.6716 15 14.5 15Z',
      key: '1aep8u',
    },
  ],
  [
    'path',
    {
      d: 'M18.5 12C19.3284 12 20 11.3284 20 10.5C20 9.67157 19.3284 9 18.5 9C17.6716 9 17 9.67157 17 10.5C17 11.3284 17.6716 12 18.5 12Z',
      key: '49o53w',
    },
  ],
]);

export default VideogameAsset;
